<template>
  <div class="contaier">
    <div class="box md:flex md:justify-between">
      <a v-if="brand?.name != 'zeekr' && phone" :href="`tel:852 ${phone}`">WhatsApp: +852 {{ phone }}</a>
      <p v-if="brand?.name">
        © {{ brand?.name == 'zeekr' ? `Auto Power Motors Limited ` : `${brand?.name.toUpperCase()} Hong Kong` }} 2026
        All rights reserved
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterPage',
  props: {
    brand: { type: Object, default: () => ({}) },
    phone: String,
  },
}
</script>
<style lang="scss" scoped>
.contaier {
  padding: 30px 20px;
  border-top: 1px solid #ddd;
  background-color: #fafafa;

  .box {
    max-width: 1200px;
    // max-width: 1240px;
    margin: 0 auto;
    font-size: 12px;
    line-height: 30px;
    // color: #fff;
  }
}
</style>
